import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "border-b border-gray-200 header-topo relative" }
const _hoisted_2 = { class: "max-w-6xl mx-auto px-4 py-3 flex items-center justify-center" }
const _hoisted_3 = {
  href: "/",
  class: "shrink-0"
}
const _hoisted_4 = { class: "ml-4" }
const _hoisted_5 = { class: "text-lg text-gray-500 ml-2 hidden sm:inline" }
const _hoisted_6 = {
  key: 0,
  class: "fixed left-4 bottom-4 z-40 w-28 opacity-50 md:opacity-100 hover:opacity-100 transition"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "absolute left-[7%] right-[7%] top-[56%] h-[24%] flex items-center justify-center text-white font-bold text-[11px] leading-tight text-center drop-shadow-sm px-1" }
const _hoisted_9 = { class: "bg-blue-700 shadow-sm relative" }
const _hoisted_10 = { class: "max-w-6xl mx-auto px-4 py-2 flex items-center" }
const _hoisted_11 = {
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_12 = {
  key: 0,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6h16M4 12h16M4 18h16"
}
const _hoisted_13 = {
  key: 1,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18L18 6M6 6l12 12"
}
const _hoisted_14 = { class: "hidden md:flex items-center gap-6" }
const _hoisted_15 = { class: "ml-auto flex items-center gap-4" }
const _hoisted_16 = {
  key: 0,
  class: "absolute -top-1.5 -right-2 inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold text-white bg-red-500 rounded-full"
}
const _hoisted_17 = { class: "text-sm text-white font-medium cursor-pointer py-2" }
const _hoisted_18 = { class: "absolute right-0 top-full bg-white border border-gray-200 rounded-lg shadow-lg py-1 min-w-[140px] z-50" }
const _hoisted_19 = {
  href: "/users/edit",
  class: "block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
}
const _hoisted_20 = {
  href: "/users/sign_out",
  "data-turbo-method": "delete",
  class: "block px-4 py-2 text-sm text-red-600 hover:bg-gray-50"
}
const _hoisted_21 = {
  href: "/users/sign_in",
  class: "text-sm text-blue-200 hover:text-white transition hidden sm:inline"
}
const _hoisted_22 = {
  href: "/users/sign_up",
  class: "text-sm text-white bg-blue-600 px-3 py-1 rounded-lg hover:bg-blue-500 transition hidden sm:inline"
}
const _hoisted_23 = { class: "flex gap-1" }
const _hoisted_24 = {
  key: 0,
  class: "md:hidden bg-blue-800 border-t border-blue-600 px-4 py-3 space-y-1"
}
const _hoisted_25 = {
  key: 0,
  class: "inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full"
}
const _hoisted_26 = {
  href: "/users/sign_in",
  class: "block py-2 text-sm text-blue-200 hover:text-white"
}
const _hoisted_27 = {
  href: "/users/sign_up",
  class: "block py-2 text-sm text-white font-medium"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["CookieBanner"]),
    _createCommentVNode(" Top header "),
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _createElementVNode("img", {
            src: "/alerg_logo_circle.png",
            alt: "Alerg.Eu",
            style: _normalizeStyle({ height: $setup.logoSize + 'px' })
          }, null, 4 /* STYLE */)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-2xl font-bold text-blue-800" }, "Alerg.Eu", -1 /* CACHED */)),
          _createElementVNode("span", _hoisted_5, "— " + _toDisplayString($setup.t('site_tagline')), 1 /* TEXT */)
        ])
      ])
    ]),
    _createCommentVNode(" Pinned Telegram button (stays in place on scroll) "),
    (!$setup.telegramClosed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("a", {
            href: "https://t.me/alerg_eu",
            target: "_blank",
            rel: "noopener",
            class: "block hover:scale-105 transition-transform",
            title: $setup.t('nav.telegram_subscribe')
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("img", {
              src: "/telegram_subscribe.png",
              alt: "Telegram",
              class: "w-full h-auto rounded-2xl shadow-md"
            }, null, -1 /* CACHED */)),
            _createElementVNode("span", _hoisted_8, _toDisplayString($setup.t('nav.telegram_subscribe')), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_7),
          _createElementVNode("button", {
            onClick: $setup.closeTelegram,
            "aria-label": "Close",
            class: "md:hidden absolute -top-2 -right-2 w-6 h-6 rounded-full bg-gray-900 text-white text-xs flex items-center justify-center shadow"
          }, " ✕ ")
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Menu bar "),
    _createElementVNode("nav", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createCommentVNode(" Hamburger (mobile) "),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => ($setup.mobileOpen = !$setup.mobileOpen)),
          class: "md:hidden text-white p-1 mr-2"
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_11, [
            (!$setup.mobileOpen)
              ? (_openBlock(), _createElementBlock("path", _hoisted_12))
              : (_openBlock(), _createElementBlock("path", _hoisted_13))
          ]))
        ]),
        _createCommentVNode(" Desktop links "),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", {
            href: "/",
            class: _normalizeClass($setup.linkClass('home'))
          }, _toDisplayString($setup.t('nav.home')), 3 /* TEXT, CLASS */),
          _createElementVNode("a", {
            href: "/shared_runs",
            class: _normalizeClass($setup.linkClass('shared_runs'))
          }, _toDisplayString($setup.t('nav.shared_runs')), 3 /* TEXT, CLASS */),
          _createElementVNode("a", {
            href: "/forum",
            class: _normalizeClass($setup.linkClass('forum'))
          }, _toDisplayString($setup.t('nav.forum')), 3 /* TEXT, CLASS */),
          _createElementVNode("a", {
            href: "/news",
            class: _normalizeClass($setup.linkClass('news'))
          }, _toDisplayString($setup.t('nav.news')), 3 /* TEXT, CLASS */),
          _createElementVNode("a", {
            href: "/competitions",
            class: _normalizeClass($setup.linkClass('competitions'))
          }, _toDisplayString($setup.t('nav.competitions')), 3 /* TEXT, CLASS */),
          _createElementVNode("a", {
            href: "/coaches",
            class: _normalizeClass($setup.linkClass('coaches'))
          }, _toDisplayString($setup.t('nav.coaches')), 3 /* TEXT, CLASS */),
          _createElementVNode("a", {
            href: "/shops",
            class: _normalizeClass($setup.linkClass('shops'))
          }, _toDisplayString($setup.t('nav.shops')), 3 /* TEXT, CLASS */),
          _createElementVNode("a", {
            href: "/split-calculator",
            class: _normalizeClass($setup.linkClass('split_calculator'))
          }, _toDisplayString($setup.t('nav.split_calculator')), 3 /* TEXT, CLASS */)
        ]),
        _createCommentVNode(" Right side: user + lang "),
        _createElementVNode("div", _hoisted_15, [
          ($props.signedIn)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createCommentVNode(" Messages icon "),
                _createElementVNode("button", {
                  onClick: $setup.toggleSidebar,
                  class: "relative text-blue-200 hover:text-white transition"
                }, [
                  _cache[5] || (_cache[5] = _createElementVNode("svg", {
                    class: "w-5 h-5",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    })
                  ], -1 /* CACHED */)),
                  ($setup.unreadCount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($setup.unreadCount > 9 ? '9+' : $setup.unreadCount), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", {
                  class: "relative",
                  onMouseenter: _cache[1] || (_cache[1] = $event => ($setup.showUserMenu = true)),
                  onMouseleave: _cache[2] || (_cache[2] = $event => ($setup.showUserMenu = false))
                }, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString($props.userName), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("div", _hoisted_18, [
                    _createElementVNode("a", _hoisted_19, _toDisplayString($setup.t('auth.edit_profile')), 1 /* TEXT */),
                    _createElementVNode("a", _hoisted_20, _toDisplayString($setup.t('auth.sign_out')), 1 /* TEXT */)
                  ], 512 /* NEED_PATCH */), [
                    [_vShow, $setup.showUserMenu]
                  ])
                ], 32 /* NEED_HYDRATION */)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("a", _hoisted_21, _toDisplayString($setup.t('auth.sign_in')), 1 /* TEXT */),
                _createElementVNode("a", _hoisted_22, _toDisplayString($setup.t('auth.sign_up')), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("a", {
              href: "/set-locale/ro",
              "data-turbo": "false",
              class: _normalizeClass(['px-2 py-1 rounded text-xs font-medium', $setup.locale === 'ro' ? 'bg-white text-blue-700' : 'bg-blue-600 text-blue-200 hover:bg-blue-500'])
            }, "RO", 2 /* CLASS */),
            _createElementVNode("a", {
              href: "/set-locale/ru",
              "data-turbo": "false",
              class: _normalizeClass(['px-2 py-1 rounded text-xs font-medium', $setup.locale === 'ru' ? 'bg-white text-blue-700' : 'bg-blue-600 text-blue-200 hover:bg-blue-500'])
            }, "RU", 2 /* CLASS */)
          ])
        ])
      ]),
      _createCommentVNode(" Mobile menu "),
      ($setup.mobileOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("a", {
              href: "/",
              class: _normalizeClass($setup.mobileLinkClass('home'))
            }, _toDisplayString($setup.t('nav.home')), 3 /* TEXT, CLASS */),
            _createElementVNode("a", {
              href: "/shared_runs",
              class: _normalizeClass($setup.mobileLinkClass('shared_runs'))
            }, _toDisplayString($setup.t('nav.shared_runs')), 3 /* TEXT, CLASS */),
            _createElementVNode("a", {
              href: "/forum",
              class: _normalizeClass($setup.mobileLinkClass('forum'))
            }, _toDisplayString($setup.t('nav.forum')), 3 /* TEXT, CLASS */),
            _createElementVNode("a", {
              href: "/news",
              class: _normalizeClass($setup.mobileLinkClass('news'))
            }, _toDisplayString($setup.t('nav.news')), 3 /* TEXT, CLASS */),
            _createElementVNode("a", {
              href: "/competitions",
              class: _normalizeClass($setup.mobileLinkClass('competitions'))
            }, _toDisplayString($setup.t('nav.competitions')), 3 /* TEXT, CLASS */),
            _createElementVNode("a", {
              href: "/coaches",
              class: _normalizeClass($setup.mobileLinkClass('coaches'))
            }, _toDisplayString($setup.t('nav.coaches')), 3 /* TEXT, CLASS */),
            _createElementVNode("a", {
              href: "/shops",
              class: _normalizeClass($setup.mobileLinkClass('shops'))
            }, _toDisplayString($setup.t('nav.shops')), 3 /* TEXT, CLASS */),
            _createElementVNode("a", {
              href: "/split-calculator",
              class: _normalizeClass($setup.mobileLinkClass('split_calculator'))
            }, _toDisplayString($setup.t('nav.split_calculator')), 3 /* TEXT, CLASS */),
            ($props.signedIn)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "border-blue-600 my-2" }, null, -1 /* CACHED */)),
                  _createElementVNode("button", {
                    onClick: $setup.toggleSidebar,
                    class: "block py-2 text-sm text-blue-200 hover:text-white flex items-center gap-2"
                  }, [
                    _createTextVNode(_toDisplayString($setup.t('messages.title')) + " ", 1 /* TEXT */),
                    ($setup.unreadCount > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString($setup.unreadCount > 9 ? '9+' : $setup.unreadCount), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (!$props.signedIn)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "border-blue-600 my-2" }, null, -1 /* CACHED */)),
                  _createElementVNode("a", _hoisted_26, _toDisplayString($setup.t('auth.sign_in')), 1 /* TEXT */),
                  _createElementVNode("a", _hoisted_27, _toDisplayString($setup.t('auth.sign_up')), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}